module.exports = __webpack_public_path__ + "img/UPLOAD.ead02b1a.svg";